import './style.less';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { keyBy, findIndex, orderBy, map, intersection } from 'lodash';
import { deliveryMethods } from '@prolaera/library';

export default function($log, $filter, $q, ApiClass, ProfileClass, CategoryClass, Swal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.timeStamp = `?time=${new Date().getTime()}`;
  vm.filteredCerts = [];

  const company_id = ProfileClass.company_id;

  vm.removeCert = cert => {
    const { profile_uid, cert_id } = cert;

    return Swal.delete()
      .then(() => {
        Swal.alert(
          'One moment...',
          "It'll take us just a moment to grab this from a binder and slam dunk it into the shredder",
          'info'
        );
        return ApiClass.usersIdTypeTypeIdDelete({
          id: profile_uid,
          type: 'certificates',
          type_id: cert_id,
          manage: false
        });
      })
      .then(() => {
        const index = findIndex(vm.certs, { profile_uid, cert_id });
        vm.certs.splice(index, 1);

        const filteredIndex = findIndex(vm.filteredCerts, { profile_uid, cert_id });
        vm.filteredCerts.splice(filteredIndex, 1);
        Swal.toast('Deleted!, Your certificate has been deleted.');
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.setFilters = (onLoad = false) => {
    vm.certsLoaded = false;
    vm.filteredCerts = [];
    vm.departmentsFilter = vm.departments.reduce(countTrue, []);
    vm.levelsFilter = vm.levels.reduce(countTrue, []);
    vm.practice_areasFilter = vm.practice_areas.reduce(countTrue, []);
    vm.locationsFilter = vm.locations.reduce(countTrue, []);
    vm.delivery_methodsFilter = vm.delivery_methods.reduce(countTrue, []);
    vm.subjectAreaFilter = vm.subjectAreas.reduce(countTrue, []);
    vm.courseSponsorsFilter = vm.courseSponsors.reduce(countTrue, []);
    vm.tagIdsFilter = vm.tagCategories.reduce((arr, tagCategory) => {
      return [...arr, ...map(tagCategory.tagsArr.filter(tag => tag.checked), 'uuid')];
    }, []);

    const subjectAreaIdsFilter = vm.subjectAreas.filter(({ checked }) => checked).map(({ category_id }) => category_id);

    vm.reportParams = {
      courseId: vm.courseIdSearch,
      courseTitle: vm.courseTitleSearch,
      date_end: vm.endDate,
      date_start: vm.startDate,
      deliveryMethods: vm.delivery_methodsFilter,
      departments: vm.departmentsFilter,
      email: vm.emailSearch,
      eventId: vm.eventIdSearch,
      first: vm.firstNameSearch,
      last: vm.lastNameSearch,
      levels: vm.levelsFilter,
      locations: vm.locationsFilter,
      practiceAreas: vm.practice_areasFilter,
      sponsorIds: vm.courseSponsorsFilter,
      subjectAreaIds: subjectAreaIdsFilter,
      tagIds: vm.tagIdsFilter
    };

    if (onLoad) {
      vm.filteredCerts = vm.certs;
      vm.certsLoaded = true;
      return;
    }

    vm.filteredCerts = vm.certs.filter(
      ({
        first,
        last,
        email,
        date,
        cert,
        department: departments,
        hours,
        level,
        practices: practice_areas,
        locations,
        delivery,
        course_id,
        event_id,
        sponsor,
        tags
      }) => {
        if (vm.firstNameSearch) {
          if (!first) return false;
          if (!first.toUpperCase().includes(vm.firstNameSearch.toUpperCase())) return false;
        }
        if (vm.lastNameSearch) {
          if (!last) return false;
          if (!last.toUpperCase().includes(vm.lastNameSearch.toUpperCase())) return false;
        }
        if (vm.emailSearch) {
          if (!email) return false;
          if (!email.toUpperCase().includes(vm.emailSearch.toUpperCase())) return false;
        }
        if (vm.courseIdSearch) {
          if (!course_id) return false;
          if (!course_id.toUpperCase().includes(vm.courseIdSearch.toUpperCase())) return false;
        }
        if (vm.courseTitleSearch) {
          if (!cert) return false;
          if (!cert.toUpperCase().includes(vm.courseTitleSearch.toUpperCase())) return false;
        }
        if (vm.eventIdSearch) {
          if (!event_id) return false;
          if (!event_id.toUpperCase().includes(vm.eventIdSearch.toUpperCase())) return false;
        }
        if (vm.levelsFilter.length) {
          if (!vm.levelsFilter.includes(level)) return false;
        }
        //Delivery_method filter
        if (vm.delivery_methodsFilter.length) {
          if (!delivery) return false;
          if (!vm.delivery_methodsFilter.includes(delivery)) return false;
        }
        //Date filters
        if (vm.startDate) {
          const currentSeconds = new Date(date).getTime();
          const startSeconds = new Date(vm.startDate).getTime();
          if (currentSeconds < startSeconds) return false;
        }
        if (vm.endDate) {
          const currentSeconds = new Date(date).getTime();
          const endSeconds = new Date(vm.endDate).getTime();
          if (currentSeconds > endSeconds) return false;
        }
        //Department filter
        if (vm.departmentsFilter.length) {
          let departmentCheck = false;
          if (!departments) return false;
          departments.forEach(department => {
            if (vm.departmentsFilter.includes(department)) return (departmentCheck = true);
          });
          if (!departmentCheck) return false;
        }
        //Department filter
        if (vm.practice_areasFilter.length) {
          let practice_areasFilterCheck = false;
          if (!practice_areas) return false;
          practice_areas.forEach(practice_areasFilter => {
            if (vm.practice_areasFilter.includes(practice_areasFilter)) return (practice_areasFilterCheck = true);
          });
          if (!practice_areasFilterCheck) return false;
        }
        //locations filter
        if (vm.locationsFilter.length) {
          let locationCheck = false;
          if (!locations) return false;
          locations.forEach(location => {
            if (vm.locationsFilter.includes(location)) return (locationCheck = true);
          });
          if (!locationCheck) return false;
        }

        //Subject Area filter
        if (vm.subjectAreaFilter.length) {
          let subjectAreaCheck = false;
          if (!hours || !hours.length) return false;
          hours.forEach(({ category_id }) => {
            if (subjectAreaIdsFilter.includes(category_id)) return (subjectAreaCheck = true);
          });
          if (!subjectAreaCheck) return false;
        }

        //Tags filter
        if (vm.tagIdsFilter.length) {
          if (!tags || !tags.length) return false;

          const tagsIntersection = intersection(tags, vm.tagIdsFilter);

          if (!tagsIntersection.length) return false;
        }

        //Course Sponsor filter
        if (vm.courseSponsorsFilter.length) {
          if (!vm.courseSponsorsFilter.includes(sponsor)) return false;
        }

        return true;
      }
    );

    vm.certsLoaded = true;
  };

  vm.downloadPDFs = () => {
    const zip = new JSZip();
    const promises = vm.filteredCerts
      .filter(({ pdf_uploaded }) => pdf_uploaded)
      .map(({ pdf, cert, cert_id, first, last }) => {
        return $q(resolve => {
          JSZipUtils.getBinaryContent(pdf + vm.timeStamp, (error, data) => {
            if (error) return resolve('NO FILE');
            const uid = $filter('uppercase')($filter('limitTo')(cert_id, 8));
            const fileName = `${cert}-${first}-${last}-${uid}.pdf`;
            zip.file(fileName, data, { binary: true });
            resolve('FILE FOUND');
          });
        });
      });

    $q.all(promises)
      .then(() => zip.generateAsync({ type: 'blob' }))
      .then(content => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(content);
        downloadLink.download = 'CertPDFs.zip';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  //Private Functions

  function countTrue(array, { name, checked }) {
    if (checked) return [...array, name];
    return array;
  }

  const deliveryMethodsDict = deliveryMethods.reduce((obj, { key, name }) => {
    obj[key] = name;
    return obj;
  }, {});

  function activate() {
    Swal.toast(
      "We're loading all of your data. \n This may take several minutes depending on how many records you have stored.\n Please do not refresh or navigate away.",
      'info',
      10000
    );

    const qArr = [
      CategoryClass.loadCategories(),
      ApiClass.scan(ApiClass.usersCertificatesGet, {}, null, {
        queryParams: {
          manage: true,
          'scan:limit': 1500
        }
      }),
      ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: {
          departments: true,
          levels: true,
          locations: true,
          practices: true
        }
      }),
      ApiClass.companiesIdTypeGet(
        {
          manage: false,
          id: company_id,
          type: 'tagCategories'
        },
        null,
        {
          queryParams: { filter: JSON.stringify({ allowedItemTypes: ['profiles'] }) }
        }
      )
    ];
    $q.all(qArr)
      .then(
        ([
          { arr: subjectAreas },
          { items: certificates },
          {
            data: { departments, levels, locations, practices }
          },
          {
            data: { items: tagCategories }
          }
        ]) => {
          tagCategories.forEach(tagCategory => {
            tagCategory.tagsArr = Object.values(tagCategory.tags || {});
          });

          vm.tagCategories = tagCategories;

          subjectAreas = orderBy(subjectAreas, ['name'], ['asc']);

          const courseSponsors = {};

          vm.subjectAreas = subjectAreas;
          vm.subjectAreasDict = keyBy(subjectAreas, 'id');
          vm.departments = departments;
          vm.departmentsDict = keyBy(departments, 'id');
          vm.levels = levels;
          vm.levelsDict = keyBy(levels, 'level_id');
          vm.practice_areas = practices;
          vm.practiceAreasDict = keyBy(practices, 'practice_id');
          vm.locations = locations;
          vm.locationsDict = keyBy(locations, 'location_id');
          vm.delivery_methods = deliveryMethods;
          vm.certs = certificates.map(cert => {
            if (cert.level) cert.level = (vm.levelsDict[cert.level] || {}).name;
            if (cert.practices) {
              cert.practices = cert.practices
                .filter(practice_id => practice_id in vm.practiceAreasDict)
                .map(practice_id => (vm.practiceAreasDict[practice_id] || {}).name);
            }
            if (cert.locations) {
              cert.locations = cert.locations
                .filter(location_id => location_id in vm.locationsDict)
                .map(location_id => (vm.locationsDict[location_id] || {}).name);
            }

            if (cert.department) {
              cert.department = cert.department
                .filter(id => id in vm.departmentsDict)
                .map(id => (vm.departmentsDict[id] || {}).name);
            }

            if (!cert.delivery && cert.delivery_uid in deliveryMethodsDict) {
              cert.delivery = deliveryMethodsDict[cert.delivery_uid].name;
            }

            if (cert.sponsor && !courseSponsors[cert.sponsor]) {
              courseSponsors[cert.sponsor] = { name: cert.sponsor, checked: false };
            }

            return cert;
          });

          vm.courseSponsorsDict = courseSponsors;
          vm.courseSponsors = orderBy(Object.values(courseSponsors), ['name'], ['asc']);

          vm.reportParams = {};

          vm.setFilters(true);
          vm.loaded = true;
        }
      )
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/certificates/report/index.js